import { render } from "./ActivitySplitButton.vue?vue&type=template&id=2cb07e22&scoped=true"
import script from "./ActivitySplitButton.vue?vue&type=script&lang=js"
export * from "./ActivitySplitButton.vue?vue&type=script&lang=js"

import "./ActivitySplitButton.vue?vue&type=style&index=0&id=2cb07e22&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb07e22"]])

export default __exports__